export const ENDPOINT = "https://leback.leform.ru";
export const CDN_ENDPOINT = "https://cdn.leform.ru";
export const API = `${ENDPOINT}/api`;
export const STORAGE = "https://cdn.leform.ru/img/storage";
export const CURRENT_HOST = "https://leform.ru";
